<script setup lang="ts">
  import type { PushToSaveScenarios } from '~/composables/PushToSave'
  import type { PushToSaveComponent } from '~/components/pushToSave/PushToSaveStateMachine.vue'
  import type { ModalSize } from '@healthpilot/nuxt-base-layer/components/hp/HpModal.vue'

  const props = withDefaults(
    defineProps<{
      id: string
      scenario: PushToSaveScenarios
      presentation: 'modal' | 'sidebar' | 'inline'
      source?: string | null | undefined
      modalSize?: string | null | undefined
      formConfig?: Record<string, any> | undefined
      initial?: PushToSaveComponent
      skipPhoneCapture?: boolean
      skipLabel?: string
    }>(),
    {
      id: 'push-to-save',
      scenario: 'add-needs',
      presentation: 'sidebar',
      modalSize: 'md',
      initial: 'signUp'
    }
  )

  const emit = defineEmits<{ skip: []; step: [state: PushToSaveComponent] }>()

  const { hide } = DialogController.use()

  const currentStep = ref<PushToSaveComponent>(props.initial)
  const isCloseLocked = computed(() => currentStep.value === 'phoneCapture')

  const onStep = (state: PushToSaveComponent) => {
    currentStep.value = state
    emit('step', state)
  }

  const onComplete = () => {
    if (props.presentation !== 'inline') hide(props.id)
  }
</script>

<template>
  <HpSidebar v-if="presentation === 'sidebar'" :id="id">
    <div class="pt-7">
      <PushToSaveStateMachine
        :scenario
        :presentation
        :initial="initial"
        :skipPhoneCapture="skipPhoneCapture"
        :onComplete
        :source="source"
        :formConfig
        @step="onStep"
      />
    </div>
    <template #footer><span /></template>
  </HpSidebar>

  <HpModal
    v-else-if="presentation === 'modal'"
    :size="(modalSize as ModalSize)"
    :id="id"
    :class="['push-to-save-modal', scenario]"
    :static="isCloseLocked"
    :hide-close-icon="isCloseLocked"
    hide-footer
    no-padding
  >
    <div class="flex min-h-[30rem] flex-col items-center justify-center">
      <PushToSaveStateMachine
        :scenario
        :presentation
        :initial="initial"
        :skipPhoneCapture="skipPhoneCapture"
        :onComplete
        :source="source"
        :formConfig
        @step="onStep"
      />
      <HpButton v-if="skipLabel" class="btn-secondary mt-3" @click="emit('skip')">
        {{ skipLabel }}
      </HpButton>
    </div>
  </HpModal>

  <div v-else class="flex flex-col items-center justify-center">
    <PushToSaveStateMachine
      :scenario
      :presentation
      :initial="initial"
      :skipPhoneCapture="skipPhoneCapture"
      :onComplete
      :source="source"
      :formConfig
      @step="onStep"
    />
  </div>
</template>

<style scoped></style>
